<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" />
    <kbo-asv-sidebar v-if="isAreaSanitariaDeVigo" />
    <kbo-sidebar v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Logo from "@/layout/components/Sidebar/Logo";
import KboSidebar from "@/layout/components/Sidebar/KboSidebar";
import KboAsvSidebar from "@/modules/areasanitariavigo/components/Sidebar";
import { getRolesForRoute } from "@/utils/roles";
import checkPermission from "@/utils/permission";
import { isAreaSanitariaDeVigo } from "@/utils/user-types";

export default {
  name: "SidebarIndex",

  components: { Logo, KboSidebar, KboAsvSidebar },

  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    ...mapGetters("operators", ["userHasManagementPermission"]),

    isAreaSanitariaDeVigo() {
      return isAreaSanitariaDeVigo();
    },

    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    isNewService() {
      return this.activeMenu.match("/services/create/");
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
  },

  methods: {
    checkPermission(route) {
      return checkPermission(getRolesForRoute(route));
    },
    createPage() {
      this.$store.commit("clientTrips/setTrip", null);
      const paramId = new Date().getTime();
      this.$router.push({ path: "/services/create/" + paramId });
    },
  },
};
</script>

<style lang="scss">
.el-menu {
  background: transparent;
}

.menu-first-level {
  display: flex;
  flex-direction: column;
  i {
    height: 22px;
  }
  .name-item {
    width: 100%;
    text-align: center;
    font-size: 8px;
  }
  .el-icon-help {
    position: relative;
    top: 1.2rem;
    left: 0.2rem;
    font-size: 22px;
  }
}
.el-menu-item {
  &:hover,
  &:focus {
    background-color: $menuBg;
  }
}
.menu-item {
  &--administration {
    background: $menuBg2;
  }
}

.el-submenu .menu-first-level {
  span {
    display: none;
  }
}
</style>
